import { proxy } from 'valtio';

/**
 * Marks if the konami code is active or not
 */
export const konamiCodeState = proxy({
  active: false,
});
